<template>
    <div>
        <div style="text-align: right;margin: auto;margin-right: 100px">
            <el-button type="text" @click="downloadResult('mainContent')" style="margin-right: 30px">导出图片</el-button>
            <el-button type="text" @click="printOutpdf('mainContent')">导出PDF</el-button>
        </div>
        <div style="width: 820px;margin: auto;text-align: center;padding: 40px 40px 130px 40px;height: auto;" id="mainContent">
            <p style="text-align: left">
                <span style="font-weight: bold">报名顺序号 : </span>
                <span>{{studentForm.studySequence}}</span>
            </p>
            <div style="height: 50px;">
                <h2>2020年湖北高校普通专升本学生报名申请表</h2>
            </div>
            <div style="width: 100%;height: auto;margin-top: 20px">
                <table width="100%" border="1" class="table-edit" style="color: #000" cellspacing="0" cellpadding="0"  align="center">
                    <tr>
                        <th>考生姓名</th>
                        <td>{{studentForm.name}}</td>
                        <th>性别</th>
                        <td>{{studentForm.sex}}</td>
                        <th>民族</th>
                        <td>{{studentForm.nation}}</td>
                        <td rowspan="4" style="width: 140px;height: 160px">
                            <img style="width: 120px; height: 140px;margin-top: 20px"  id="faceImg" src="" />
                        </td>
                    </tr>
                    <tr>
                        <th>出生日期</th>
                        <td>
                            <span v-if="studentForm.birthday">{{studentForm.birthday.replace('-','/').replace('-','/')}}</span>
                            <span v-else></span>
                        </td>
                        <th colspan="2">政治面貌</th>
                        <td colspan="2">{{studentForm.politicalAffiliation}}</td>
                    </tr>
                    <tr style="height: 40px">
                        <th>身份证号</th>
                        <td colspan="5" style="width: 615px !important;">
                            <span v-for="(card,index) in studentForm.idCard">
                                <span style="width: 32.8px;display: block;float: left;height: 40px;line-height: 40px;border-right: solid 1px #000"  v-if="(index+1) !=18">{{card}}</span>
                                <span style="width: 32.8px;display: block;float: left;height: 40px;line-height: 40px;" v-else>{{card}}</span>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>高考报名号</th>
                        <td colspan="5" style="width: 615px !important;">
                            <span v-for="(code,index) in studentForm.studyCode">
                                <span style="width: 41.8px;display: block;float: left;height: 40px;line-height: 40px;border-right: solid 1px #000"  v-if="(index+1) !=14">{{code}}</span>
                                <span style="width: 41.8px;display: block;float: left;height: 40px;line-height: 40px;" v-else>{{code}}</span>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>毕业学校</th>
                        <td colspan="3">{{studentForm.univerColleges}}</td>
                        <th>毕业专业</th>
                        <td colspan="2">{{studentForm.studyMajor}}</td>
                    </tr>
                    <tr>
                        <th>报考院校</th>
                        <td colspan="6">{{studentForm.studyColleges}}</td>
                    </tr>
                    <tr>
                        <th>报考专业</th>
                        <td colspan="3">{{studentForm.examMajor}}</td>
                        <th>报考专业代码</th>
                        <td colspan="2">{{studentForm.examMajorCode}}</td>
                    </tr>
                    <tr style="height: 60px">
                        <th>在校期间受过何种奖励</th>
                        <td colspan="4">{{studentForm.reward}}</td>
                        <th>有何特长</th>
                        <td>{{studentForm.speciality}}</td>
                    </tr>
                    <tr>
                        <th>家庭住址</th>
                        <td colspan="4">{{studentForm.homeAddress}}</td>
                        <th>联系电话</th>
                        <td>{{studentForm.phone}}</td>
                    </tr>
                    <tr>
                        <th>联系地址</th>
                        <td colspan="4">{{studentForm.address}}</td>
                        <th>邮编</th>
                        <td>{{studentForm.adressCode}}</td>
                    </tr>
                    <tr>
                        <td colspan="3" style="width: 200px">
                            <div style="width: 273px;height: 200px">
                                <p style="text-align: left;margin-left: 10px;margin-top: 10px">申请须知与承诺：</p>
                                <div style="height: 100px;">
                                    <p style="text-align: left;margin-top: -5px;margin-left: 10px">1、本人是2020年应届普通高职/高专毕业生，能够如期毕业并获得毕业证书。</p>
                                    <p style="text-align: left;margin-top: -5px;margin-left: 10px">2、本人在校期间未受到任何纪律处分。</p>
                                    <p style="text-align: left;margin-top: -5px;margin-left: 10px">3、本人保证提供的信息真实。</p>
                                </div>
                                <p style="text-align: left;margin-top: -5px;margin-left: 10px">申请人（签名）：</p>
                                <p style="text-align: right">
                                    <span style="margin-right: 20px">年</span>
                                    <span style="margin-right: 20px">月</span>
                                    <span style="margin-right: 20px">日</span>
                                </p>
                            </div>
                        </td>
                        <td colspan="2" style="width: 200px;">
                            <div style="width: 273px;height: 200px">
                                <p style="text-align: left;margin-left: 10px">申请者所在高校学籍管理部门审核：</p>
                                <div style="height: 100px;">
                                    <p style="text-align: left;margin-left: 10px">该生属于我校应届普通全日制在校高职（专科）学生，已取得普通专科学籍。</p>
                                </div>
                                <p style="text-align: left;margin-top: -5px;margin-left: 10px">负责人签字（单位盖章）：</p>
                                <p style="text-align: right;">
                                    <span style="margin-right: 20px">年</span>
                                    <span style="margin-right: 20px">月</span>
                                    <span style="margin-right: 20px">日</span>
                                </p>
                            </div>
                        </td>
                        <td colspan="2">
                            <div style="width: 273px;height: 200px">
                                <p style="text-align: left;margin-top: -5px;margin-top: 10px;margin-left: 10px">本科院校意见：：</p>
                                <div style="height: 100px;">
                                </div>
                                <p style="text-align: left;margin-top: -5px;margin-left: 10px">负责人签字（单位盖章）：</p>
                                <p style="text-align: right">
                                    <span style="margin-right: 20px">年</span>
                                    <span style="margin-right: 20px">月</span>
                                    <span style="margin-right: 20px">日</span>
                                </p>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div style="height: 60px;text-align: left;">
                <p>填表说明：</p>
                <p>1.本表一式三份,申请者、申请者毕业学校和举办高校各留存一份。</p>
                <p>2.所有信息在上交前必须认真核对，准确无误，如因本人填写错误导致资格审查不能通过，由申请者本人负责。</p>
                <p>3.报名手续由申请者本人办理，不得委托他人代办。填写信息不实者，一经查实，将取消其普通专升本资格。</p>
                <p>4.高考报名号由申请者所在高职院校学籍管理部门提供或填写。</p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf'
    let loading;
    export default {
        name: "sysScoreLook",
        components: { noData },
        data() {
            return {
                studentForm: {

                },
                config:config
            }
        },
        created(){
        },
        mounted(){
            this.submit();
        },
        methods: {
            submit(){
                axios({
                    url:`${home}/sysStudent/ignore/findMySelf`,
                    method:'GET',
                }).then(res=>{
                    this.studentForm=res.data;
                    this.getUrlBase64(config.resPre+res.data.faceImg, "jpg", function (base64) {
                        document.getElementById("faceImg").src = base64;
                    });
                }).catch(function (error) {
                    console.log(error);
                });
            },
            dataURLToBlob(dataurl) {//ie 图片转格式
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime})
            },
            downloadResult(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let canvasID = document.getElementById(name);
                let a = document.createElement('a');
                html2canvas(canvasID).then(canvas => {
                    let dom = document.body.appendChild(canvas);
                    dom.style.display = "none";
                    a.style.display = "none";
                    document.body.removeChild(dom);
                    let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
                    a.setAttribute("href", URL.createObjectURL(blob));
                    a.setAttribute("download", this.studentForm.name + "的报名申请表.png")
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(blob);
                    document.body.removeChild(a);
                    loading.close();
                });
            },
            /**
             *
             * @param url 图片路径
             * @param ext 图片格式
             * @param callback 结果回调
             */
            getUrlBase64(url, ext, callback) {
                var canvas = document.createElement("canvas");   //创建canvas DOM元素
                var ctx = canvas.getContext("2d");
                var img = new Image;
                img.crossOrigin = 'Anonymous';
                img.src = url;
                img.onload = function () {
                    canvas.height = 140; //指定画板的高度,自定义
                    canvas.width = 120; //指定画板的宽度，自定义
                    ctx.drawImage(img, 0, 0, 140, 120); //参数可自定义 高度，宽度
                    var dataURL = canvas.toDataURL("image/" + ext);
                    callback.call(this, dataURL); //回掉函数获取Base64编码
                    canvas = null;
                };

            },
            printOut(name) {
                // 个人观察只是截取可见范围以及以下的区域，所以先将滚动条置顶
                $(window).scrollTop(0); // jQuery 的方法
                document.body.scrollTop = 0; // IE的
                document.documentElement.scrollTop = 0; // 其他
                this.downloadResult(name)
            },
            printOutpdf(name) {
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let shareContent = document.getElementById(name),//需要截图的包裹的（原生的）DOM 对象
                    width = shareContent.clientWidth, //获取dom 宽度
                    height = shareContent.clientHeight, //获取dom 高度
                    canvas = document.createElement("canvas"), //创建一个canvas节点
                    scale = 2; //定义任意放大倍数 支持小数
                canvas.width = width * scale; //定义canvas 宽度 * 缩放
                canvas.height = height * scale; //定义canvas高度 *缩放
                canvas.style.width = shareContent.clientWidth * scale + "px";
                canvas.style.height = shareContent.clientHeight * scale + "px";
                canvas.getContext("2d").scale(scale, scale); //获取context,设置scale
                let opts = {
                    scale: scale, // 添加的scale 参数
                    canvas: canvas, //自定义 canvas
                    logging: false, //日志开关，便于查看html2canvas的内部执行流程
                    width: width, //dom 原始宽度
                    height: height,
                    useCORS: true, // 【重要】开启跨域配置
                };
                html2canvas(shareContent).then(canvas => {
                    var contentWidth = canvas.width;
                    var contentHeight = canvas.height;
                    //一页pdf显示html页面生成的canvas高度;
                    var pageHeight = (contentWidth / 592.28) * 841.89;
                    //未生成pdf的html页面高度
                    var leftHeight = contentHeight;
                    //页面偏移
                    var position = 0;
                    //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                    var imgWidth = 595.28;
                    var imgHeight = (592.28 / contentWidth) * contentHeight;
                    var pageData = canvas.toDataURL("image/jpeg", 1.0);
                    var PDF = new JsPDF("", "pt", "a4");
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0) {
                                PDF.addPage();
                            }
                        }
                    }
                    PDF.save(this.studentForm.name + "的报名申请表.pdf"); // 这里是导出的文件名
                    loading.close();
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    tr{
        height: 40px;
    }
    td{
        width: 160px;
    }
    th{
        width: 100px;
    }
</style>